import React from 'react';
import { Check } from 'lucide-react';
import StepShell from './StepShell';
import type { FlowCtx } from './types';

interface Props {
  ctx: FlowCtx;
}

const Step8DeviceConnected: React.FC<Props> = ({ ctx }) => {
  return (
    <StepShell
      stepNumber={4}
      secondary={{ label: 'Add Device', onClick: ctx.navigateToAddDevice }}
      primary={{ label: 'Go to Dashboard', onClick: ctx.navigateToDashboard }}
    >
      <div className="dcf-content--center">
        <h2 className="dcf-step-title">
          Step 4 of 4: Device connected successfully
        </h2>
        <div className="dcf-step-bar"></div>
        <div className='dcf-image-source'>
          <picture>
            <source
              srcSet={`${process.env.PUBLIC_URL}/DeviceSetup/device-mobile.avif`}
              type="image/avif"
            />
            <img
              srcSet={`${process.env.PUBLIC_URL}/DeviceSetup/device-mobile.webp`}
              alt="SmartEco IAQ device"
              className="dcf-illustration"
            />
          </picture>
          
          <picture className='dcf-indicator'>
            <source
              srcSet={`${process.env.PUBLIC_URL}/DeviceSetup/all-success-indicator.avif`}
              type="image/avif"
            />
            <img
              src={`${process.env.PUBLIC_URL}/DeviceSetup/all-success-indicator.webp`}
              alt="SmartEco IAQ device"
              className="dcf-indicator-image"
            />
          </picture>

          <div className="dcf-status-icon dcf-step7-status-icon" aria-hidden="true">
            <Check strokeWidth={2} />
          </div>
        </div>
        
        <span className='dcf-step-subtitle live'>Your device is live!</span>
        <p className="dcf-step-subtitle">
          Your SmartEco device is live.
          {ctx.isFirstOnboarding
            ? ' The device is initializing — first readings will appear on your dashboard within 2–3 minutes.'
            : ' Air quality readings will appear on your dashboard shortly.'}
        </p>

        <ul className="dcf-info-list" style={{ marginTop: 8 }}>
          {ctx.isFirstOnboarding && (
            <li className="dcf-info-list__item">
              Device status: <strong>Initializing</strong> — waiting for first data
            </li>
          )}
          <li className="dcf-info-list__item">
            Device will upload readings automatically
          </li>
          <li className="dcf-info-list__item">
            View live data on the Smart Eco dashboard
          </li>
          <li className="dcf-info-list__item">
            Add more devices anytime from the menu
          </li>
        </ul>
      </div>
    </StepShell>
  );
};

export default Step8DeviceConnected;
